import React from 'react';

import { useQuery } from '@tanstack/react-query';
import { IDataPool } from '../../types/my-types';

import Dropdown from './Dropdown';
import usePublicDataPools from '../hooks/usePublicDataPools';
import useDataPool from '../hooks/useDataPool';

export interface SelectPublicDataPoolProps {
  setDataPool: (dataPool: IDataPool | undefined) => void;
  currentDataPoolId: string;
  currentDataPoolLabel: string;
  style?: any;
}

interface IDatapoolItemsForDropdown {
  id: string;
  label: string;
}

const SelectPublicDataPool: React.FC<SelectPublicDataPoolProps> = ({
  currentDataPoolId,
  currentDataPoolLabel,
  setDataPool,
  style,
}) => {
  let publicDataPools = usePublicDataPools();

  const { data: currentDataPool, isLoading, isFetching } = useDataPool();

  let items: IDatapoolItemsForDropdown[] = [];

  if (publicDataPools.data) {
    // List all public data pools
    items = publicDataPools?.data.results.map((dp: IDataPool) => ({
      id: dp.id,
      label: dp.label,
    }));

    // Add the existing data pool to the list
    items.push({
      id: currentDataPoolId,
      label: `${currentDataPoolLabel} [CURRENT]`,
    });
  }

  const selectDataPool = (value: string) => {
    if (value === '') {
      setDataPool(undefined);
      return;
    }

    if (publicDataPools?.data?.results) {
      let allDataPools: IDataPool[] = [...(publicDataPools.data.results || [])];
      if (currentDataPool) {
        allDataPools.push(currentDataPool);
      }

      const selectedDataPool = allDataPools.find((t: IDataPool) => t.id === value);
      setDataPool(selectedDataPool);
    }
  };

  return (
    <Dropdown
      style={style}
      items={items}
      onChangeCallback={selectDataPool}
      placeholderTitle="Select Data Pool"
      disabled={isLoading || isFetching}
      cypressId="select-public-data-pool"
      size="small"
    />
  );
};

export default SelectPublicDataPool;
